import {IQueryFilter} from './filters';

export interface ISearchQuery {
    general: ISearchGeneral;
    filters: IQueryFilter[];
}

export interface ISearchGeneral {
    name: string;
    isDefault: boolean;
    isAbsoluteDefault: boolean;
    ignoreCase: boolean;
}

export const KEY_PREFIX = 'APP_GENERATOR_SEARCHES';

export const SEARCH_INIT: ISearchGeneral = {
    name: '',
    isDefault: false,
    isAbsoluteDefault: false,
    ignoreCase: true
};
